import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  exportTemplateTimeKeepingStart,
  exportTemplateTimeKeepingSuccess,
  exportTemplateTimeKeepingFailed,
} from "../redux/exportTemplateTimeKeeping";

import { toast } from "react-toastify";
import { exportTemplateTimeKeepingApi } from "core/http/service/timeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { formInputImportSelector } from "../redux/selector";
import moment from "moment";

function* exportTemplateTimeKeepingWork() {
  try {
    const form = yield select(formInputImportSelector);
    const month = moment(form?.monthSelected).month() + 1;
    const year = moment(form?.monthSelected).year();

    const res = yield call(exportTemplateTimeKeepingApi, SCREEN.IP_021, {
      month,
      year,
    });

    const blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `Template chấm công.xlsx`; // Name of the file to download

    // Append link to body and trigger download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put({
      type: exportTemplateTimeKeepingSuccess.type,
    });
    toast.success("Tải xuống file mẫu thành công");
  } catch (error: any) {
    yield put({
      type: exportTemplateTimeKeepingFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportTemplateTimeKeeping() {
  yield takeLatest(
    exportTemplateTimeKeepingStart.type,
    exportTemplateTimeKeepingWork
  );
}

export default function* exportTemplateTimeKeepingSaga() {
  yield all([watchExportTemplateTimeKeeping()]);
}
